module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid unauthorized"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "formulario-top"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("VOLVER!")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title.toUpperCase()))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description.toUpperCase()))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signboard"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-693d4b3f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Unauthorized/Unauthorized.vue
// module id = 1706
// module chunks = 6